"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _GeoCellLayer2 = _interopRequireDefault(require("../geo-cell-layer/GeoCellLayer"));

var _s2Utils = require("./s2-utils");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var defaultProps = {
  getS2Token: {
    type: 'accessor',
    value: function value(d) {
      return d.token;
    }
  }
};

var S2Layer = function (_GeoCellLayer) {
  (0, _inherits2.default)(S2Layer, _GeoCellLayer);

  var _super = _createSuper(S2Layer);

  function S2Layer() {
    (0, _classCallCheck2.default)(this, S2Layer);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(S2Layer, [{
    key: "indexToBounds",
    value: function indexToBounds() {
      var _this$props = this.props,
          data = _this$props.data,
          getS2Token = _this$props.getS2Token;
      return {
        data: data,
        _normalize: false,
        positionFormat: 'XY',
        getPolygon: function getPolygon(x, objectInfo) {
          return (0, _s2Utils.getS2Polygon)(getS2Token(x, objectInfo));
        }
      };
    }
  }]);
  return S2Layer;
}(_GeoCellLayer2.default);

exports.default = S2Layer;
(0, _defineProperty2.default)(S2Layer, "layerName", 'S2Layer');
(0, _defineProperty2.default)(S2Layer, "defaultProps", defaultProps);
//# sourceMappingURL=s2-layer.js.map